/* - progress bar - */

const progressBar__milstones = progressBar_milestones_data;
const customerTags = progressBar__milstones.customerTags;
let country = window.Shopify.country;
console.log(country);
const progressBar__element = () => {
  const progressBar = document.querySelector('.drawer__progress-bar');
  if (progressBar) {
    const text = progressBar.querySelector('.drawer__progress-bar--text');
    const bar = progressBar.querySelector('.drawer__progress-bar--bar');
    const inner = progressBar.querySelector('.drawer__progress-bar--inner');
    return { progressBar, text, bar, inner };
  }
  return null;
};

const ProgressBar__milestone = (cart_value) => {
  if (country != 'DE') {
    // check if country is in progressBar__milstones.byCountry
    if (country in progressBar__milstones.byCountry) {
      return progressBar_getCurrentMilestone(progressBar__milstones.byCountry[country], cart_value);
    }
    return progressBar_getCurrentMilestone(progressBar__milstones.defaultInternational, cart_value);
  }

  //check if one of the customer tags is matching with progressBar__milstones.byTag
  for (let i = 0; i < customerTags.length; i++) {
    if (customerTags[i] in progressBar__milstones.byTag) {
      console.log('customer tag found');
      console.log(progressBar__milstones.byTag[customerTags[i]]);
      return progressBar_getCurrentMilestone(progressBar__milstones.byTag[customerTags[i]], cart_value);
    }
  }

  return progressBar_getCurrentMilestone(progressBar__milstones.default, cart_value);
};

const progressBar_getCurrentMilestone = (milestones, cart_value) => {
  var current_milestone = null;

  for (let i = 0; i < milestones.length; i++) {
    if (cart_value < toCent(milestones[i].total)) {
      current_milestone = milestones[i];
      current_milestone.succeeded = false;
      return milestones[i];
    }
  }
  current_milestone = milestones[milestones.length - 1];
  current_milestone.succeeded = true;

  return current_milestone;
};

const ProgressBar__update = (milestone, cart_value) => {
  var displayText = '';
  var progress = 0;

  if (milestone.succeeded) {
    displayText = milestone.name + ' erreicht';
    progress = 100;
  } else {
    const missing = toCent(milestone.total) - cart_value;
    console.log(missing);
    console.log(milestone.total);
    console.log(cart_value);
    console.log(toCent(milestone.total));
    const missing_euro = missing / 100;
    displayText = 'Noch <b>' + missing_euro + '€</b> bis zum <b>' + milestone.name + '</b>';
    progress = (cart_value / toCent(milestone.total)) * 100;
  }

  const progressBar = progressBar__element();
  if (progressBar) {
    progressBar.text.innerHTML = displayText;
    progressBar.inner.style.width = progress + '%';
  } else {
    console.error('Progressbar not found');
  }
};

const ProgressBar = () => {
  const cart = myCartWatcher.storedCart();
  const cart_value = cart.total_price - pfandCount * 25;
  const milestone = ProgressBar__milestone(cart_value);

  console.log(progressBar__milstones);
  console.log(cart);
  console.log(cart_value);
  console.log(milestone);

  ProgressBar__update(milestone, cart_value);
};

const toCent = (euro) => {
  return euro * 100;
};

/* - Pfand - */

const pfandVariantID = '47293328392533';
var itemsCount = 0;
var pfandCount = 0;

function changeCartNumber() {
  try {
    document.querySelector('.cart-count-bubble').textContent = itemsCount;
  } catch (error) {
    // console.log(error);
  }
}

var fetchPfandIsRunning = false;
const fetchPfand = async (operation) => {
  // console.log('Callign FetchPfand w ' + operation);
  try {
    var body = JSON.stringify({ id: pfandVariantID, quantity: pfandCount });

    const response = await fetch(window.Shopify.routes.root + 'cart/' + operation + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: body,
    });
    // console.log(await response.json());

    if (response.ok) {
      const event = new CustomEvent('cart:refresh', { bubbles: true });
      document.documentElement.dispatchEvent(event);
    } else {
      throw new Error('Network response was not ok');
    }
    return response.ok;
  } catch (error) {
    console.error('Error:', error);
    return false;
  }
};

function pfandAmountByType(type) {
  if (!type.includes('Tray')) return 0;
  else return type.match(/\d+/)[0];
}

async function addPfand() {
  // console.log('calling: addPfand');
  const cart = myCartWatcher.storedCart();
  const cartItems = cart.items;

  var pfandItem = null;
  pfandCount = 0;
  itemsCount = 0;
  Object.values(cartItems).forEach((item) => {
    var productType = item.product_type;
    if (productType == 'pfand') {
      pfandItem = item;
    } else {
      pfandCount += pfandAmountByType(productType) * item.quantity;
      itemsCount += item.quantity;
    }
  });
  changeCartNumber();
  pfandQuantity = pfandItem ? pfandItem.quantity : 0;
  if (!pfandItem && pfandCount > 0) return await fetchPfand('add');
  if (pfandQuantity != pfandCount) return await fetchPfand('change');
}

function PfandIsOk() {
  // console.log('calling: checkPfand');
  const cart = myCartWatcher.storedCart();
  const cartItems = cart.items;

  var pfandItem = null;
  pfandCount = 0;
  itemsCount = 0;
  Object.values(cartItems).forEach((item) => {
    var productType = item.product_type;
    if (productType == 'pfand') {
      pfandItem = item;
    } else {
      pfandCount += pfandAmountByType(productType) * item.quantity;
      itemsCount += item.quantity;
    }
  });
  changeCartNumber();
  pfandQuantity = pfandItem ? pfandItem.quantity : 0;
  // console.log(pfandItem);
  // console.log('pfandCount ' + pfandCount + ' pfandQuantity ' + pfandQuantity);
  if (!pfandItem && pfandCount > 0) return false;
  if (pfandQuantity != pfandCount) return false;
  return true;
}
//- get Checkout Button

function activatePfandButton() {
  var checkoutButton = document.querySelector('button.cart__checkout-button');
  checkoutButton.style.display = 'none';

  if (document.getElementById('pfandButton') != null) return;
  var pfandButton = document.createElement('button');
  pfandButton.innerHTML = 'Preis berechnen';
  pfandButton.classList.add('button');
  pfandButton.setAttribute('id', 'pfandButton');
  checkoutButton.parentNode.insertBefore(pfandButton, checkoutButton);

  pfandButton.addEventListener('click', function () {
    // console.log('clickevent');
    addPfand();
    this.remove();
  });
}

function disableCheckoutbutton() {
  var checkoutButton = document.querySelector('button.cart__checkout-button');
  checkoutButton.disabled = true;
}
function enableCheckoutbutton() {
  var checkoutButton = document.querySelector('button.cart__checkout-button');
  if (checkoutButton.classList.contains('disabled')) return;
  checkoutButton.disabled = false;
}

async function onCartChange() {
  ProgressBar();
  addCartInputListeners();
  if (PfandIsOk()) {
    enableCheckoutbutton();
  } else {
    disableCheckoutbutton();
    await addPfand();
  }
}

function addCartInputListeners() {
  var cartInputs = document.querySelectorAll('.quantity, .cart-remove-button');

  cartInputs.forEach((elem) => {
    elem.addEventListener('click', function () {
      // console.log('clickevent');
      disableCheckoutbutton();
    });
  });
}

// -- Listen Cart Updates -->

class CartWatcher {
  init() {
    this.emitCartChanges().then(() => {
      this.observeCartChanges();
    });
  }

  async fetchCart() {
    //await limitWatcher.call();
    const response = await fetch('/cart.js');
    return response.json();
  }

  storeCart(cart) {
    localStorage.setItem('cart', JSON.stringify(cart));
  }

  storedCart() {
    return JSON.parse(localStorage.getItem('cart')) || { items: [] };
  }

  findCartChanges(oldCart, newCart) {
    const onlyInLeft = (l, r) => l.filter((li) => !r.some((ri) => li.key == ri.key));
    let result = {
      added: onlyInLeft(newCart.items, oldCart.items),
      removed: onlyInLeft(oldCart.items, newCart.items),
    };

    oldCart.items.forEach((oi) => {
      const ni = newCart.items.find((i) => i.key == oi.key && i.quantity != oi.quantity);
      if (!ni) return;
      let quantity = ni.quantity - oi.quantity;
      let item = { ...ni };
      item.quantity = Math.abs(quantity);
      quantity > 0 ? result.added.push(item) : result.removed.push(item);
    });

    return result;
  }

  async emitCartChanges() {
    const newCart = await this.fetchCart();
    const oldCart = this.storedCart();
    const changes = this.findCartChanges(oldCart, newCart);

    const event = new CustomEvent('cart_changed', { detail: changes });

    this.storeCart(newCart);
    window.dispatchEvent(event); //Changed so cart update is b4 event
  }

  observeCartChanges() {
    const cartObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
        const isCartChangeRequest = /\/cart\//.test(entry.name);
        if (isValidRequestType && isCartChangeRequest) {
          this.emitCartChanges();
        }
      });
    });
    cartObserver.observe({ entryTypes: ['resource'] });
  }
}

const myCartWatcher = new CartWatcher();
myCartWatcher.init();
window.addEventListener('cart_changed', (e) => {
  //onCartChange();
  setTimeout(onCartChange, 10);
});
onCartChange();
// onCartChange();
